import getActionUrl from '../utilities/getActionUrl';

export default function NotificationPopoverListItemActions({
  notification,
  navigate,
  scope,
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {notification.actions?.map((action) => (
        <a
          key={`notification-${notification.id}-action-${action.url}`}
          className="text-xs font-semibold text-orange-700 hover:underline"
          href={getActionUrl(action, navigate, scope)}
        >
          {action.label}
        </a>
      ))}
    </div>
  );
}
